<template>
  <div>
    <div class="header">
      <b-container fluid>
        <div class="top_header">
          <div class="logo">
            <b-link to="/">
              <b-img fluid :src="require('@/assets/images/logo5.png')"></b-img>
            </b-link>
          </div>
          <div class="lang_section">
            <div class="lang_button">
              <div class="switch switch--horizontal">
                <input id="radio-a" type="radio" name="first-switch" checked />
                <label for="radio-a">English</label>
                <input id="radio-b" type="radio" name="first-switch" />
                <label for="radio-b">Filipino</label>
                <span class="toggle-outside">
                  <span class="toggle-inside"></span>
                </span>
              </div>
            </div>
            <b-link to="/login" class="signin_btn">Sign In</b-link>
          </div>
        </div>
      </b-container>
      <div class="navigation_bar">
        <b-container fluid>
          <b-nav>
            <b-nav-item to="/">Apply a loan</b-nav-item>
            <b-nav-item to="/repayment">Repayment</b-nav-item>
            <b-nav-item to="/news">News &amp; Promos</b-nav-item>
            <b-nav-item to="/faqs">Faqs</b-nav-item>
            <b-nav-item to="/contacts">Contact</b-nav-item>
          </b-nav>
        </b-container>
      </div>
      <div class="nav-fixed-top">
        <b-navbar>
          <b-container fluid>
            <h4>RAJ5 Lending Corporation</h4>
            <b-navbar-nav>
              <b-nav-item to="/">Apply a Loan</b-nav-item>
              <b-nav-item to="/repayment">Repayment</b-nav-item>
              <b-nav-item to="/news">News &amp; Promos</b-nav-item>
              <b-nav-item to="/faqs">Faqs</b-nav-item>
              <b-nav-item to="/contacts">Contact</b-nav-item>
            </b-navbar-nav>
          </b-container>
        </b-navbar>
      </div>
    </div>
    <div class="header_mobile">
      <b-container fluid>
        <b-button v-b-toggle.sidebar-backdrop>
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </b-button>
        <div class="logo">
          <img src="@/assets/images/logo5.png" alt="Logo" />
        </div>
        <b-sidebar id="sidebar-backdrop" backdrop shadow>
          <div class="lang_section">
            <div class="lang_button">
              <div class="switch switch--horizontal">
                <input id="m-radio-a" type="radio" name="first-switch" />
                <label for="m-radio-a">English</label>
                <input id="m-radio-b" type="radio" name="first-switch" />
                <label for="m-radio-b">Filipino</label>
                <span class="toggle-outside">
                  <span class="toggle-inside"></span>
                </span>
              </div>
            </div>
          </div>
          <div class="sidebar_nav">
            <b-navbar-nav>
              <b-nav-item to="/">Apply a Loan</b-nav-item>
              <b-nav-item to="/repayment">Repayment</b-nav-item>
              <b-nav-item to="/news">News &amp; Promos</b-nav-item>
              <b-nav-item to="/faqs">Faqs</b-nav-item>
              <b-nav-item to="/contacts">Contact</b-nav-item>
              <b-nav-item to="/login">Sign In</b-nav-item>
            </b-navbar-nav>
          </div>
        </b-sidebar>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerComponent",
  data() {
    return {
      selected: false
    };
  },
  methods: {
    scrollNav() {
      window.addEventListener("scroll", function() {
        if (window.scrollY > 300) {
          document.querySelector(".nav-fixed-top").classList.add("fixed");
        } else {
          document.querySelector(".nav-fixed-top").classList.remove("fixed");
        }
      });
    }
  },
  beforeMount() {
    this.scrollNav();
  }
};
</script>

<style lang="scss">
.b-sidebar-body {
  background: $base-blue-nav url('../assets/images/banner-blue.jpg') no-repeat;
  background-size: cover;
  background-position: top left;
}
</style>
<style lang="scss" scoped>
.header {
  background-color: #fff;
  .top_header {
    .logo {
      img {
        max-width: 180px;
        max-height: 90px;
      }
    }
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .lang_section {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .lang_button {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 80px;
        p {
          margin-bottom: 0;
          font-weight: 700;
        }
      }
      .signin_btn {
        padding: 7px 30px;
        border: 1px solid $base-color-blue;
        background-color: $base-bgcolor-lightblue;
        border-radius: 4px;
        color: $base-color-blue;
        text-transform: uppercase;
        font-weight: 600;
        text-decoration: none;
      }
    }
  }
  .navigation_bar {
    background: $base-blue-nav;
    border-top: 1px solid #dddddd;
    .container-fluid {
      display: flex;
      align-items: center;
      .nav {
        display: flex;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          a {
            color: #fff;
            text-transform: uppercase;
            width: 100%;
            justify-content: center;
            display: flex;
            align-items: center;
            height: 45px;
            min-width: 190px;
          }
          a:hover,
          a:focus {
            background: $base-color-blue;
            color: #fff;
          }
          a.router-link-exact-active {
            background-color: #063f73;
            color: #fff;
          }
        }
      }
    }
  }
  .nav-fixed-top {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    transition: all 0.3s;
    opacity: 0;
    visibility: hidden;
    .navbar {
      background: $base-blue-nav;
      h4 {
        color: #fff;
        font-size: 20px;
        margin: 0;
      }
      ul li a {
        color: #fff;
        font-size: 14px;
      }
    }
  }
  .nav-fixed-top.fixed {
    opacity: 1;
    visibility: visible;
  }
}
.header_mobile {
  display: none;
  .container-fluid {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    .btn {
      background: transparent;
      border: 0;
    }
    .btn:active,
    .btn:focus,
    .btn:active:focus {
      background: transparent;
      border: 0;
      outline: none;
      box-shadow: none;
    }
    .btn:hover {
      opacity: 0.8;
    }
    .bar {
      width: 35px;
      height: 5px;
      background-color: $base-blue-nav;
      margin: 6px 0;
    }
    .logo {
      display: block;
      margin: 0 auto;
      img {
        max-width: 175px;
        max-height: 70px;
        padding: 6px 0;
      }
    }
    .lang_section {
      background: #f8f9fa;
      padding: 0 0 20px;
    }
    .sidebar_nav {
      padding: 20px 0;
      a {
        color: #fff;
      }
      ul li a {
        color: #fff;
        padding: 10px 20px;
      }
      ul li a.router-link-exact-active {
        background: $base-color-lightblue;
      }
    }
  }
}
.switch {
  width: 24rem;
  position: relative;
}

.switch input {
  position: absolute;
  top: 0;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}

.switch input:checked {
  z-index: 1;
}

.switch input:checked + label {
  opacity: 1;
  cursor: default;
}

.switch input:not(:checked) + label:hover {
  opacity: 0.5;
}

.switch label {
  opacity: 0.33;
  transition: opacity 0.25s ease;
  cursor: pointer;
  text-transform: uppercase;
}

.switch .toggle-outside {
  height: 100%;
  border-radius: 2rem;
  padding: 0.25rem;
  overflow: hidden;
  transition: 0.25s ease all;
}

.switch .toggle-inside {
  border-radius: 5rem;
  background: #f4f4f4;
  position: absolute;
  transition: 0.25s ease all;
}

.switch--horizontal {
  width: 18rem;
  height: 40px;
  margin: 0 auto;
  font-size: 0;
}

.switch--horizontal input {
  height: 40px;
  width: 6rem;
  left: 6rem;
  margin: 0;
}

.switch--horizontal label {
  font-size: 14px;
  line-height: 39px;
  display: inline-block;
  width: 6rem;
  height: 100%;
  margin: 0;
  text-align: center;
  font-weight: 600;
}

.switch--horizontal label:last-of-type {
  margin-left: 6rem;
}

.switch--horizontal .toggle-outside {
  background: $base-blue-nav;
  position: absolute;
  width: 6rem;
  left: 6rem;
}

.switch--horizontal .toggle-inside {
  height: 32px;
  width: 40px;
}

.switch--horizontal input:checked ~ .toggle-outside .toggle-inside {
  left: 0.25rem;
}

.switch--horizontal input ~ input:checked ~ .toggle-outside .toggle-inside {
  left: 3.25rem;
}
@media (max-width: 1024px) {
  .header {
    display: none;
  }
  .header_mobile {
    display: block;
  }
}
</style>